// angular import
import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationsService } from '../configuration/service/configurations.service';
import { LanguageService } from 'src/app/multi-language/language.service';
// import { ConfigurationsService } from '../configuration/service/configurations.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent {
  // public props
  @Output() onNavCollapse = new EventEmitter();
  @Output() onNavCollapsedMob = new EventEmitter();
  navCollapsed;
  navCollapsedMob;
  windowWidth: number;
  langset;
  themeConfig;


  // constructor
  constructor(public translate: TranslateService,
    public languageService: LanguageService,
    private ConfigurationsService: ConfigurationsService
  ) {
    this.ConfigurationsService.getConfig().subscribe((res) => {
      this.themeConfig = res;
      this.windowWidth = window.innerWidth;
      this.navCollapsed =
        this.windowWidth >= 992 ? this.themeConfig.isCollapseMenu : true;
      this.navCollapsedMob = false;
    });
    this.langset = this.translate.getBrowserLang();
    localStorage.setItem('lang', this.langset);
  }

  navCollapse() {
    this.windowWidth = window.innerWidth;
    this.navCollapsed = !this.navCollapsed;
    this.onNavCollapse.emit();
  }

  navCollapseMob() {
    if (this.windowWidth < 992) {
      this.onNavCollapsedMob.emit();
    }
  }

}
